import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, Link } from 'react-router-dom';
import { Building2, Users2, Home, Mail, FileText } from 'lucide-react';
import './styles.css';

export default function PartnerNavBar() {
  const { user, logout, isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const [showAccessMenu, setShowAccessMenu] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  return (
    <nav className="partner-navbar">
      <div className="partner-navbar-container">
        {/* Left: Logo/Brand */}
        <div className="partner-navbar-brand">
          <Link to="/partner" className="logo-link">
            <img src="/images/evmonogram.png" alt="EternaVaults" className="partner-navbar-monogram" />
            <div className="brand-text">
              <span className="partner-navbar-logo">EternaVaults</span>
              <span className="partner-navbar-subtitle">Partner Console</span>
            </div>
          </Link>
        </div>

        {/* Center: Access Button */}
        <div className="partner-navbar-center">
          <div className="access-menu-wrapper">
            <button
              className="access-button"
              onClick={() => setShowAccessMenu(!showAccessMenu)}
              onBlur={() => setTimeout(() => setShowAccessMenu(false), 200)}
            >
              <span>Access</span>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            {showAccessMenu && (
              <div className="access-dropdown">
                <Link
                  to="/partner"
                  className="access-menu-item"
                  onClick={() => setShowAccessMenu(false)}
                >
                  <span className="access-menu-icon">
                    <Building2 size={20} className="access-menu-icon-svg" />
                  </span>
                  <div>
                    <div className="access-menu-title">Partner Portals</div>
                    <div className="access-menu-desc">Manage your partner account</div>
                  </div>
                </Link>

                <Link
                  to="/partner/families"
                  className="access-menu-item"
                  onClick={() => setShowAccessMenu(false)}
                >
                  <span className="access-menu-icon">
                    <Users2 size={20} className="access-menu-icon-svg" />
                  </span>
                  <div>
                    <div className="access-menu-title">Family Portals</div>
                    <div className="access-menu-desc">Manage family vaults</div>
                  </div>
                </Link>

                <Link
                  to="/partner/communications"
                  className="access-menu-item"
                  onClick={() => setShowAccessMenu(false)}
                >
                  <span className="access-menu-icon">
                    <Mail size={20} className="access-menu-icon-svg" />
                  </span>
                  <div>
                    <div className="access-menu-title">Communications</div>
                    <div className="access-menu-desc">Client engagement tools</div>
                  </div>
                </Link>

                <Link
                  to="/partner/reports"
                  className="access-menu-item"
                  onClick={() => setShowAccessMenu(false)}
                >
                  <span className="access-menu-icon">
                    <FileText size={20} className="access-menu-icon-svg" />
                  </span>
                  <div>
                    <div className="access-menu-title">Continuity Reports</div>
                    <div className="access-menu-desc">Generate status reports</div>
                  </div>
                </Link>

                <Link
                  to="/member-selection"
                  className="access-menu-item"
                  onClick={() => setShowAccessMenu(false)}
                >
                  <span className="access-menu-icon">
                    <Home size={20} className="access-menu-icon-svg" />
                  </span>
                  <div>
                    <div className="access-menu-title">Family Portals</div>
                    <div className="access-menu-desc">Access family vaults</div>
                  </div>
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* Right: Profile Menu */}
        <div className="partner-navbar-right">
          {isAuthenticated && user && (
            <div className="profile-menu-wrapper">
              <button
                className="profile-button"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
                onBlur={() => setTimeout(() => setShowProfileMenu(false), 200)}
              >
                <div className="partner-profile-avatar">
                  {user.picture ? (
                    <img src={user.picture} alt={user.name} />
                  ) : (
                    <span>{user.name?.charAt(0) || 'U'}</span>
                  )}
                </div>
                <span className="profile-name">{user.name || user.email}</span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {showProfileMenu && (
                <div className="profile-dropdown">
                  <Link
                    to="/partner/account"
                    className="profile-menu-item"
                    onClick={() => setShowProfileMenu(false)}
                  >
                    My Account
                  </Link>
                  <Link
                    to="/partner/branding"
                    className="profile-menu-item"
                    onClick={() => setShowProfileMenu(false)}
                  >
                    Branding & Settings
                  </Link>
                  <div className="profile-menu-divider"></div>
                  <button
                    className="profile-menu-item logout"
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

